import React from 'react';
import { Clock, Users } from 'lucide-react';

const SchedulePage = () => {
  const schedule = [
    {
      day: 'Tuesday',
      classes: [
        { time: 'No Classes', name: 'Rest Day', level: '', color: 'gray' }
      ]
    },
    {
      day: 'Wednesday',
      classes: [
        { time: 'No Classes', name: 'Rest Day', level: '', color: 'gray' }
      ]
    },
    {
      day: 'Thursday',
      classes: [
        { time: 'No Classes', name: 'Rest Day', level: '', color: 'gray' }
      ]
    },
    {
      day: 'Friday',
      classes: [
        { time: '18:30 - 20:30', name: 'Karate Class - All Ages', level: 'All Levels', color: 'red', location: 'Brotherhood Hall, St Oysth Road' }
      ]
    },
    {
      day: 'Saturday',
      classes: [
        { time: 'No Classes', name: 'Rest Day', level: '', color: 'gray' }
      ]
    },
    {
      day: 'Sunday',
      classes: [
        { time: 'Closed', name: 'Rest & Recovery', level: '', color: 'gray' }
      ]
    }
  ];

  const classDescriptions = [
    {
      name: 'Friday Classes',
      description: '18:30-20:30 at Brotherhood Hall, St Oysth Road. Comprehensive karate instruction in a supportive environment. Students learn traditional techniques while having fun and making friends.'
    },
    {
      name: 'First Session Free',
      description: 'Try San Kai Karate with a FREE first session! New students also train for FREE during school half-term breaks. After that, it\'s just £6 for 2 hours of training.'
    }
  ];

  return (
    <div className="page-wrapper schedule-page">
      <div className="page-header">
        <div className="container">
          <h1 className="page-title">Training Schedule</h1>
          <p className="page-subtitle">
            Join us every Friday evening for training at Brotherhood Hall, St Oysth Road, Clacton-on-Sea.
          </p>
        </div>
      </div>

      <div className="container">
        {/* Schedule Grid */}
        <div className="schedule-grid">
          {schedule.filter(day => day.classes[0].color !== 'gray').map((day) => (
            <div key={day.day} className="schedule-day-card">
              <h3 className="schedule-day-title">{day.day}</h3>
              <div className="schedule-classes">
                {day.classes.map((classItem, index) => (
                  <div key={index} className={`schedule-class ${classItem.color}`}>
                    <div className="schedule-class-time">
                      <Clock size={16} />
                      <span>{classItem.time}</span>
                    </div>
                    <h4 className="schedule-class-name">{classItem.name}</h4>
                    {classItem.level && (
                      <div className="schedule-class-level">
                        <Users size={14} />
                        <span>{classItem.level}</span>
                      </div>
                    )}
                    {classItem.location && (
                      <div className="schedule-class-location">
                        <span>{classItem.location}</span>
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>

        {/* Class Descriptions */}
        <div className="class-descriptions">
          <h2 className="section-title">Class Information</h2>
          <div className="descriptions-grid">
            {classDescriptions.map((item, index) => (
              <div key={index} className="description-card">
                <h3 className="description-title">{item.name}</h3>
                <p className="description-text">{item.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SchedulePage;